import React from 'react'
import { Dropdown } from 'primereact/dropdown'
import { MediaDeviceInfoMediaDeviceSelection } from '../_core/hooks/useMediaDevices'

export type MediaDeviceOptions = {
  audio:MediaDeviceInfoMediaDeviceSelection[]
  video:MediaDeviceInfoMediaDeviceSelection[]
}
export type MediaDevicesSelected = {
  show:boolean
  audio?:MediaDeviceInfoMediaDeviceSelection
  video?:MediaDeviceInfoMediaDeviceSelection
}

export type PropsMediaDeviceSelection = {
  audio?:boolean
  video?:boolean
  devices:MediaDeviceOptions
  value:MediaDevicesSelected | undefined
  onChange:(_:MediaDevicesSelected) => void
  maxWidth?:number
}

export default React.memo((props:PropsMediaDeviceSelection) => {
  console.log('MediaDeviceSelection.rendering',props)
  return <div className="m-auto position-relative w-100" style={{ 'maxWidth':props.maxWidth && (props.maxWidth+'px')}}>{
    props.value?.show
    ? <>
      <div className="position-absolute overflow-visible z-1 top-100 end-0">
        <i className="pi pi-wrench position-absolute text-primary" style={{ 'right':'-20px' }} onClick={() => props.onChange({ ...props.value,'show':false })}></i>
      </div>
      {!props.audio ? <></> :
      <div className="m-auto py-2 d-flex align-items-center position-relative">
        <i className="pi pi-volume-up fs-4 position-absolute" style={{ 'left':'-30px' }}></i>
        <Dropdown
          options={props.devices.audio || []}
          optionValue="deviceId"
          optionLabel="label"
          value={props.value?.audio?.deviceId || props.devices.audio.find((x) => x.deviceId === 'default')?.deviceId || props.devices.audio[0]?.deviceId}
          onChange={(e) => props.onChange({ ...props.value,'audio':props.devices.audio.find((x) => x.deviceId == e.value),'show':true })}
        ></Dropdown>
      </div>
      }
      {!props.video ? <></> :
      <div className="m-auto py-2 d-flex align-items-center position-relative">
        <i className="pi pi-video fs-4 position-absolute" style={{ 'left':'-30px' }}></i>
        <Dropdown
          options={props.devices.video || []}
          optionValue="deviceId"
          optionLabel="label"
          value={props.value?.video?.deviceId || props.devices.video.find((x) => x.deviceId === 'default')?.deviceId || props.devices.video[0]?.deviceId}
          onChange={(e) => props.onChange({ ...props.value,'video':props.devices.video.find((x) => x.deviceId == e.value),'show':true })}
        ></Dropdown>
      </div>
      }
    </>
    : <>
      <div className="position-absolute overflow-visible z-1 top-100 end-0">
        <i className="pi pi-wrench position-absolute" style={{ 'right':'-20px' }} onClick={() => props.onChange({ ...props.value,'show':true })}></i>
      </div>
    </>
  }</div>
})
